module.exports = __webpack_public_path__ + "static/media/essence-of-kernelcon-2.65b6aca4.jpeg";